import Vue from 'vue'
import Vuex from 'vuex'
import { createStore } from "vuex";
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store(
{
	state: 
	{
		// 登录
		loginData:'',
		// 
		seletVal:'',
		classifyVal:'',
		sonClassifyVal:''
	},
	mutations: 
	{
		setLoginData(state,data)
		{
			state.loginData=data;
		},
		setModuleName(state,data)
		{
			state.seletVal=data;
		},
		setClassifyValName(state,data)
		{
			state.classifyVal=data;
		},
		setSonClassifyValName(state,data)
		{
			state.sonClassifyVal=data;
		},
	},
	actions: 
	{
		Login({commit},data)
		{
			commit("setLoginData",data)
		},
		ModuleName({commit},data)
		{
			commit("setModuleName",data)
		},
		ClassifyValName({commit},data)
		{
			commit("setClassifyValName",data)
		},
		SonClassifyValName({commit},data)
		{
			commit("setSonClassifyValName",data)
		},
	},
	modules: 
	{
		
	},
	getters: 
	{
		
	},
	plugins: [
		persistedState({ storage: window.sessionStorage })
	]
})